(function () {
    'use strict';

    run.admin.pages.apiDashboard = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const save_uri_button = document.getElementById('btn_save_oauth2_redirect_uri');
        const redirect_uri_input = document.getElementById('redirect_uri');

        let changed = false;

        redirect_uri_input.addEventListener('input', function(e) {
            changed = true;
            save_uri_button.removeAttribute('disabled');
        })

        document.addEventListener('click',function(e) {
            let clicked_save_button = e.target.closest('#btn_save_oauth2_redirect_uri');
            if (clicked_save_button) {
                const appUuid = save_uri_button.dataset.appUuid;
                editOauth2RedirectUri(appUuid);
            }
        });

        function editOauth2RedirectUri(app_uuid = null) {
            if (app_uuid == null || app_uuid.length == 0) { return; }

            Swal.fire({
                title: translations.apiDashboard.updateRedirectUri.messages.title,
                html: translations.apiDashboard.updateRedirectUri.messages.body,
                showCancelButton: true,
                cancelButtonText: translations.apiDashboard.updateRedirectUri.messages.buttonCancel,
                confirmButtonText: translations.apiDashboard.updateRedirectUri.messages.buttonConfirm,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('app_id', app_uuid);
                    data.append('redirect_uri', redirect_uri_input.value);

                    axios.post(GlobalRoutes.api.apps.edit, data)
                    .then(function (response) {
                        save_uri_button.setAttribute('disabled', 'disabled');
                        new Toast(translations.apiDashboard.updateRedirectUri.messages.success, Toast.TYPE_DONE, Toast.TIME_NORMAL);
                    })
                    .catch(function (error) {
                        new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    });
                }
            });
        }
    }
})();
